import { apiClient } from '../apiClient';

export type ApiUser = {
  id: string;
  email: string;
  display_name: string;
  is_hr: boolean;
  /** HR = full access; REVIEWER = manager / team lead, Candidates screen only. */
  role?: 'HR' | 'REVIEWER';
};

/** Older cached sessions have no `role`: fall back to `is_hr`. */
export const isReviewerUser = (user: ApiUser | null | undefined) =>
  Boolean(user) && (user!.role ? user!.role === 'REVIEWER' : !user!.is_hr);

type MicrosoftExchangePayload = {
  access_token?: string;
  id_token: string;
};

export const exchangeMicrosoftAuthToken = (payload: MicrosoftExchangePayload) =>
  apiClient.post<ApiUser>('/auth/microsoft/exchange', payload);

export const getCurrentUser = () => apiClient.get<ApiUser>('/me');
